<template>
  <validation-provider :rules="{ required: !isOptional }" :disabled="isOptional" v-slot="{ errors }" slim :immediate="validateImmediate">
    <div v-if="question.hspQuestionTypeId !== 5" class="d-md-table-row pb-4 pb-md-0">
      <div v-if="!isMatrixMode && errors[0]">
        <h6 class="text-danger mb-md-1">{{ errors[0] }}</h6>
      </div>
      <div class="d-block d-md-table-cell" :style="{ width: questionWidth, 'background-color': questionBkgrndColor }">
        <div v-if="isMatrixMode && errors[0]">
          <h6 class="text-danger mb-md-1">{{ errors[0] }}</h6>
        </div>
        <span v-html="number" class="number-text"></span><span v-html="question.questionText"></span>
      </div>
      <div
        v-for="response in question.responses"
        :key="response.hspResponseId"
        class="d-block d-md-table-cell text-md-center"
        :style="{ width: responseWidth, 'background-color': responsesBkgrndColor }">
        <base-radio
          :name="response.hspResponseId"
          :value="stateResponseId"
          :isDarkMode="isDarkMode"
          :isDesktop="isDesktop"
          @input="handleInput"
          :inline="true">
          <span v-html="response.responseTitle" class="d-md-none pl-2"></span>
        </base-radio>
      </div>
    </div>
  </validation-provider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';
import { isDesktopSize } from 'src/modules/utils';

export default {
  components: {
    ValidationProvider
  },
  props: {
    question: {
      type: Object,
      required: true,
      default: function() {
        return {
          responses: []
        }
      }
    },
    number: String,
    hasAlternatingBkgrndColor: Boolean,
    alternatingBackColor: String,
    questionBackColor: String,
    responsesBackColor: String,
    sectionId: {
      type: Number,
      required: true,
      description: 'Needed to disable validation when section is not active.'
    },
    displayOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    validateImmediate: Boolean,
    isDarkMode: Boolean,
  },
  data() {
    return {
      defaultQuestionWidth: 40
    }
  },
  computed: {
    isDesktop() {
      return isDesktopSize(this.windowWidth);
    },
    isDisplayed() {
      return this.sectionId === this.activeSectionId;
    },
    isOptional() {
      if(this.isDisplayed && this.question.isRequired === true) {
        return false;
      }

      return true;
    },
    stateResponseId() {
      return this.$store.getters.getQuestionResponseId(this.question.hspCategoryQuestionId);
    },
    isMatrixMode() {
      return isDesktopSize(this.windowWidth);
    },
    questionWidth() {
      if (isDesktopSize(this.windowWidth)) {
        return `${this.defaultQuestionWidth}%`;
      }

      return '100%';
    },
    responseWidth() {
      if (isDesktopSize(this.windowWidth)) {
        let width = (100 - this.defaultQuestionWidth) / this.question.responses.length;

        return `${width}%`;
      }

      return '100%';
    },
    questionBkgrndColor() {
      if (this.hasAlternatingBkgrndColor && isDesktopSize(this.windowWidth)) {
        return this.alternatingBackColor;
      }

      return this.questionBackColor;
    },
    responsesBkgrndColor() {
      // Display the alternating background color for the responses, if available and in desktop size (matrix configuration).
      if (this.hasAlternatingBkgrndColor && isDesktopSize(this.windowWidth)) {
        return this.alternatingBackColor;
      }

      return this.responsesBackColor;
    },
    ...mapGetters([
      'windowWidth',
      'activeSectionId',
      'displayTypeOptions'
    ]),
  },
  methods: {
    handleInput(value, hasTextField) {
      this.$store.dispatch('setQuestionResponse', {
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseId: value
      });
    },
  },
  created() {
    let displayOption = this.displayOptions
      .find(displayOption => displayOption.optionId === this.displayTypeOptions.MATRIX_QUESTION_WIDTH);

    if(displayOption) {
      this.defaultQuestionWidth = displayOption.optionValue;
    }
  }
}
</script>
